import { esEstatusCancelado } from './policyStatuses.js';

// CAMBIAR EL ESTATUS DE VARIAS POLIZAS: LAS CUENTAS QUE SE ENSENAN ANTES.
//
// Luis Rodriguez, 2026-09-10, por soporte: pregunto como cambiar el estatus de
// varias polizas de golpe y le dijeron que no se podia. Era verdad.
//
// Esto vive SUELTO, sin importar nada de React, por lo mismo que
// `moverPoliza.js`: la prueba del servidor puede comprobar que lo que la
// pantalla PROMETE antes de pulsar es lo que el servidor hace despues. Una
// pantalla que dice "se cambian 20" sobre una seleccion donde 8 ya estaban asi
// es la que acaba en soporte preguntando por que el numero no cuadra.

/**
 * Que va a pasar con la seleccion si se elige `destino` (y, al cancelar, esa
 * `fecha`).
 *
 * `polizas` son las de la pantalla (su `status` es el id de la pantalla: uno de
 * serie o el id del estatus propio de la agencia), no las filas del servidor.
 *
 * - `total`   cuantas hay elegidas
 * - `cambian` cuantas cambiarian de verdad
 * - `yaEstan` cuantas se quedan exactamente igual (no se tocan)
 * - `saltanACancelada` cuantas PASAN a cancelada — las unicas que podrian
 *   disparar la automatizacion de retencion, y por eso se cuentan aparte: es el
 *   numero que se le ensena al lado de la casilla que la enciende.
 *
 * LA FECHA CUENTA COMO CAMBIO, y no es un detalle: una poliza ya cancelada a la
 * que le falta la fecha de cancelacion —las hay, de antes de que fuera
 * obligatoria— SI cambia si se le pone. Contarla como "ya esta" dejaria el
 * boton en "Cambiar 0" y sin poder pulsarlo, justo para el unico arreglo que
 * hace falta hacer en lote.
 */
export function resumenDelCambio(polizas, destino, fecha) {
  const lista = Array.isArray(polizas) ? polizas : [];
  const elegido = String(destino || '');
  const dia = String(fecha || '').trim();
  let yaEstan = 0;
  let cambian = 0;
  let saltanACancelada = 0;
  for (const p of lista) {
    const actual = String((p && p.status) || '');
    const mismoEstatus = !!elegido && actual === elegido;
    const cambiaLaFecha = pideFechaDeCancelacion(elegido)
      && !!dia
      && String((p && p.cancellationDate) || '').slice(0, 10) !== dia;
    if (mismoEstatus && !cambiaLaFecha) { yaEstan += 1; continue; }
    cambian += 1;
    if (pideFechaDeCancelacion(elegido) && !esEstatusCancelado(actual)) saltanACancelada += 1;
  }
  return { total: lista.length, cambian, yaEstan, saltanACancelada };
}

/**
 * El estatus elegido obliga a poner fecha de cancelacion.
 *
 * No solo el 'cancelled' de fabrica: tambien el estatus PROPIO de la agencia
 * que se llama "Cancelada". Desde el 2026-09-15 ese tambien se guarda con el
 * enum CANCELLED (policyStatuses.js#estadoParaElServidor), y el servidor pide
 * la fecha para CANCELLED venga de donde venga; sin esto el lote entero se iba
 * en un error rojo despues de elegir veinte polizas.
 */
export const pideFechaDeCancelacion = (destino) => esEstatusCancelado(destino);

/**
 * Si se puede pulsar el boton. Separado del componente para poder probarlo. Dos
 * casos, y los dos acaban en soporte si se dejan pasar:
 *
 * - cancelar SIN fecha: el servidor rechaza el lote entero y la agente se queda
 *   con un error rojo despues de elegir veinte polizas (la fecha es con lo que
 *   la agencia cuadra las devoluciones de comision).
 * - un boton que no cambiaria nada: "Cambiar 0" no es un boton, es una duda.
 */
export function sePuedeCambiar({ destino, fecha, cambian }) {
  if (!destino || !cambian) return false;
  if (pideFechaDeCancelacion(destino) && !String(fecha || '').trim()) return false;
  return true;
}
